import QRCode from "qrcode";

export const generateQRCodeDataURL = async (token: string) => {
  console.log('Generating QR code for token:', token);
  const surveyUrl = `https://fosforskning.se/survey/${token}`;
  return await QRCode.toDataURL(surveyUrl, {
    width: 300,
    margin: 2,
    color: {
      dark: "#000000",
      light: "#ffffff",
    },
  });
};

// Using only unambiguous characters:
// Removed: 0,O,1,I,l,5,S,2,Z,B,8,6,9,G
const UNAMBIGUOUS_CHARS = "ACDEFHJKLMNPQRTUVWXY347";

export const generateRandomToken = () => {
  let token = '';
  const tokenLength = 6;
  
  // Create an array of crypto random values
  const randomValues = new Uint8Array(tokenLength);
  window.crypto.getRandomValues(randomValues);
  
  // Generate the token using crypto random values
  for (let i = 0; i < tokenLength; i++) {
    const randomIndex = randomValues[i] % UNAMBIGUOUS_CHARS.length;
    token += UNAMBIGUOUS_CHARS[randomIndex];
  }
  
  console.log('Generated token:', token);
  return token;
};

// Validate token format
export const isValidToken = (token: string): boolean => {
  if (!token || token.length !== 6) return false;
  
  // Check if token only contains allowed characters
  const validChars = new Set(UNAMBIGUOUS_CHARS.split(''));
  return token.split('').every(char => validChars.has(char));
};